import { render } from "./HomeItem.vue?vue&type=template&id=53b34332"
import script from "./HomeItem.vue?vue&type=script&lang=js"
export * from "./HomeItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__